import * as React from 'react'

const SvgAsLevelIcon = (props) => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.58333 13.333H2.58333C1.84695 13.333 1.25 12.7361 1.25 11.9997V2.66634C1.25 1.92996 1.84695 1.33301 2.58333 1.33301H11.9167C12.653 1.33301 13.25 1.92996 13.25 2.66634V11.9997C13.25 12.7361 12.653 13.333 11.9167 13.333H10.9167M7.25 12.6663C8.35457 12.6663 9.25 11.7709 9.25 10.6663C9.25 9.56177 8.35457 8.66634 7.25 8.66634C6.14543 8.66634 5.25 9.56177 5.25 10.6663C5.25 11.7709 6.14543 12.6663 7.25 12.6663ZM7.25 12.6663L7.26429 12.6662L5.13578 14.7947L3.25016 12.9091L5.2631 10.8962M7.25 12.6663L9.37854 14.7947L11.2642 12.9091L9.25122 10.8962M5.25 3.99967H9.25M3.91667 6.33301H10.5833"
      stroke="white"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgAsLevelIcon
